import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { USER_ROLE } from "../../components/security/UserRole";
import { history } from "../../components/helpers/History";
import { AdminActions } from "../../redux/actions/AdminActions";
import { AppConstants } from "../../components/constants/ApplicationConstants";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },title:{
    margin: theme.spacing(2, 0, 2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class AdminProfile extends React.Component {
  constructor(props) {
    super(props);
    const { userid } = this.props.match.params;
    console.log("userid => " + userid);
    this.state = {
      userid: userid,
      isEditFlow: false,
      user: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNo: "",
        status: "",
        userRole: "",
        hospitalId: "",
      },
      submitted: false,
    };
  }
  componentDidMount() {
    if (this.state.userid && this.state.userid.length > 0) {
      this.props.getUserById(this.state.userid);
    } else {
      this.props.getUserById(this.props.loginUserId);
    }
  }
  updateUser() {
    console.log(this.props.profile);
    this.setState({
      user: {
        id: this.props.profile.id,
        firstName: this.props.profile.firstName,
        lastName: this.props.profile.lastName,
        email: this.props.profile.email,
        phoneNo: this.props.profile.telePhoneNo,
        status: this.props.profile.status,
        userRole: this.props.profile.userRole,
        hospitalId: this.props.profile.hospitalId,
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.user &&
      this.props.profile &&
      this.state.user.id != this.props.profile.id &&
      this.props.profile.id &&
      this.props.profile.id.length > 0
    ) {
      this.updateUser();
    }
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Admin details</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
          <CssBaseline />
          <Box sx={{ mb: 3}} className={classes.title}>
            <Typography gutterBottom variant="h4" color="primary">
              Admin details
            </Typography>
          </Box>
          <Paper className={classes.paper}>
            <Formik
              enableReinitialize
              initialValues={{
                id: this.state.user.id,
                firstName: this.state.user.firstName,
                lastName: this.state.user.lastName,
                email: this.state.user.email,
                phoneNo: this.state.user.phoneNo,
                status: this.state.user.status,
                userRole: this.state.user.userRole,
                hospitalId: this.state.user.hospitalId,
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .email("Must be a valid email")
                  .max(100)
                  .required("Email is required"),
                firstName: Yup.string()
                  .max(30)
                  .required("First name is required"),
                lastName: Yup.string()
                  .max(30)
                  .required("Last name is required"),
                phoneNo: Yup.string()
                  .matches(/^[0-9]+$/, "Must be only digits")
                  .min(10, "Must be exactly 10 digits")
                  .max(10, "Must be exactly 10 digits")
                  .required("Phone number required"),
                status: Yup.string().ensure().required("Status is required"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                //this.setState({ submitted: true });
                this.props.submit(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className={classes.form}
                  noValidate
                  name="form"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.firstName && errors.firstName)}
                        fullWidth
                        helperText={touched.firstName && errors.firstName}
                        label="First Name"
                        margin="normal"
                        name="firstName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.firstName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.lastName && errors.lastName)}
                        fullWidth
                        helperText={touched.lastName && errors.lastName}
                        label="Last Name"
                        margin="normal"
                        name="lastName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.lastName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label="Email"
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.phoneNo && errors.phoneNo)}
                        fullWidth
                        helperText={touched.phoneNo && errors.phoneNo}
                        label="Phone No."
                        margin="normal"
                        name="phoneNo"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phoneNo}
                        variant="outlined"
                      />
                    </Grid>
                    {this.state.user.userRole === USER_ROLE.HCP_ADMIN ? (
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          margin="normal"
                          variant="outlined"
                          className={classes.formControl}
                          fullWidth
                        >
                          <InputLabel htmlFor="hospitalId-label">
                            Hospital Name
                          </InputLabel>
                          <Select
                            native
                            disabled={
                              this.props.userRole === USER_ROLE.HCP_ADMIN
                                ? true
                                : false
                            }
                            value={values.hospitalId}
                            error={Boolean(
                              touched.hospitalId && errors.hospitalId
                            )}
                            helperText={touched.hospitalId && errors.hospitalId}
                            label="Hospital Name"
                            inputProps={{
                              name: "hospitalId",
                              id: "hospitalId-label",
                            }}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <option aria-label="None" value="" />
                            {AppConstants.HOSPITAL_NAME_LIST.map((element) => {
                              return (
                                <option value={element.name}>
                                  {element.name}
                                </option>
                              );
                            })}
                          </Select>
                          {errors.hospitalName && touched.hospitalName && (
                            <FormHelperText style={{ color: "#f44336" }}>
                              {errors.hospitalId}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    ) : null}
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        margin="normal"
                      >
                        <InputLabel htmlFor="status-label">Status</InputLabel>
                        <Select
                          native
                          disabled={
                            this.props.userRole === USER_ROLE.HCP_ADMIN
                              ? true
                              : false
                          }
                          value={values.status}
                          error={Boolean(touched.status && errors.status)}
                          helperText={touched.status && errors.status}
                          label="Status"
                          inputProps={{
                            name: "status",
                            id: "status-label",
                          }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option aria-label="None" value="" />
                          {AppConstants.USER_STATUS_LIST.map((element) => {
                            return (
                              <option value={element.value}>
                                {element.label}
                              </option>
                            );
                          })}
                        </Select>
                        {errors.status && touched.status && (
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.status}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>

                  <div className={classes.buttons}>
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const loginUserId = state.authentication.user.id;
  const profile = state.admin.profile;
  const userRole = state.authentication.user.userRole;
  return { loginUserId, profile, userRole };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUserById: (id) => {
      dispatch(AdminActions.getUserById(id));
    },
    submit: (value) => {
      dispatch(AdminActions.udpateAdmin(value));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(AdminProfile));
